// Local adaptation of Fanxing Dev's visitor-chat protocol. Never import its checkout.
export const CUSTOMER_SERVICE_API = '/api/customer-service';
export const CUSTOMER_SERVICE_SITE = 'fxcs_duanju_school_v1';
export const CUSTOMER_SERVICE_STORAGE = `fanxing-customer-service:${CUSTOMER_SERVICE_SITE}:v1`;
export type VisitorCredentials = { sessionId: string; token: string };
export type VisitorSession = { id: string; siteName: string; visitorCode: string; expiresAt: string };
export type VisitorMessage = { id: string; sequence: number; senderName: string; text: string; mine: boolean; createdAt: string };

export class VisitorChatError extends Error {
  status: number;
  code: string;
  constructor(status: number, code: string) { super(code); this.status = status; this.code = code; }
}
export function readVisitorCredentials(storage: Pick<Storage, 'getItem'>): VisitorCredentials | null {
  try {
    const value = JSON.parse(storage.getItem(CUSTOMER_SERVICE_STORAGE) || 'null');
    return typeof value?.sessionId === 'string' && value.sessionId && typeof value.token === 'string' && value.token
      ? { sessionId: value.sessionId, token: value.token } : null;
  } catch { return null; }
}
export function saveVisitorCredentials(storage: Pick<Storage, 'setItem' | 'removeItem'>, value: VisitorCredentials | null) {
  // Storage restrictions must not turn a successful server connection into a failure.
  try {
    if (value) storage.setItem(CUSTOMER_SERVICE_STORAGE, JSON.stringify(value));
    else storage.removeItem(CUSTOMER_SERVICE_STORAGE);
  } catch { /* The session still works in this tab. */ }
}
export function mergeVisitorMessages(current: VisitorMessage[], incoming: VisitorMessage[]) {
  const byId = new Map(current.map(message => [message.id, message]));
  incoming.forEach(message => byId.set(message.id, message));
  return Array.from(byId.values()).sort((a, b) => a.sequence - b.sequence);
}
export async function visitorRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(CUSTOMER_SERVICE_API + path, {
    ...init, cache: 'no-store', credentials: 'omit', redirect: 'error', signal: AbortSignal.timeout(15_000),
  });
  const payload = await response.json();
  if (!response.ok) throw new VisitorChatError(response.status, payload.message || `HTTP_${response.status}`);
  return payload as T;
}
